export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '294deg',
  'gradient-primary': '#1f3e62',
  'gradient-secondary': '#1f3e62',

  'primary-color': '#1f3e62',
  'secondary-color': '#1f3e62',
  'auxiliary-color': '#1f3e62',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#1f3e62',
  'secondary-button-color': '#1f3e62',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#1f3e62',
  'secondary-button-border-hover': '#1f3e62',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#1A1A1A',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#C7DEFF',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#1f3e62',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#1f3e62',
  'entry-message-color': '#1f3e62',

  'bg-modal-color': '#FFFFFF',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#1f3e62;',
  'text-gray': '#4F4F4F',

  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#C7DEFF',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#1f3e62',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#1f3e62',
  'echeck-bar-color2': '#1f3e62'
};
